// THUMBNAILS

// Layout
import workSpace01 from "../assets/thumbnails/layout/Work_Space_01.png";
import workSpace02 from "../assets/thumbnails/layout/Work_Space_02.png";
import workSpace03 from "../assets/thumbnails/layout/Work_Space_03.png";

// Floor
import woodFloor1 from "../assets/thumbnails/floor/Floor_Wood_01.png";
import woodFloor2 from "../assets/thumbnails/floor/Floor_Wood_02.png";
import woodFloor3 from "../assets/thumbnails/floor/Floor_Wood_03.png";
import concreteFloor1 from "../assets/thumbnails/floor/Floor_Concrete_01.png";
import concreteFloor2 from "../assets/thumbnails/floor/Floor_Concrete_02.png";
import concreteFloor3 from "../assets/thumbnails/floor/Floor_Concrete_03.png";
import carpetFloor1 from "../assets/thumbnails/floor/Floor_Carpet_01.png";
import carpetFloor2 from "../assets/thumbnails/floor/Floor_Carpet_02.png";
import carpetFloor3 from "../assets/thumbnails/floor/Floor_Carpet_03.png";

// Ceiling
import woodCeiling1 from "../assets/thumbnails/ceiling/Ceiling_Wood_01.png";
import woodCeiling2 from "../assets/thumbnails/ceiling/Ceiling_Wood_02.png";
import woodCeiling3 from "../assets/thumbnails/ceiling/Ceiling_Wood_3.png";
import concreteCeiling1 from "../assets/thumbnails/ceiling/Ceiling_Concrete_01.png";
import concreteCeiling2 from "../assets/thumbnails/ceiling/Ceiling_Concrete_02.png";
import concreteCeiling3 from "../assets/thumbnails/ceiling/Ceiling_Concrete_03.png";
import plasterCeiling1 from "../assets/thumbnails/ceiling/Ceiling_Plaster_01.png";
import plasterCeiling2 from "../assets/thumbnails/ceiling/Ceiling_Concrete_02.png";
import plasterCeiling3 from "../assets/thumbnails/ceiling/Ceiling_Concrete_03.png";

// Wall
import woodWall1 from "../assets/thumbnails/wall/Wall_Wood_01.png";
import woodWall2 from "../assets/thumbnails/wall/Wall_Wood_02.png";
import woodWall3 from "../assets/thumbnails/wall/Wall_Wood_03.png";
import bricksWall1 from "../assets/thumbnails/wall/Wall_Brick_01.png";
import bricksWall2 from "../assets/thumbnails/wall/Wall_Brick_02.png";
import bricksWall3 from "../assets/thumbnails/wall/Wall_Brick_03.png";
import plasterWall1 from "../assets/thumbnails/wall/Wall_Plaster_01.png";
import plasterWall2 from "../assets/thumbnails/wall/Wall_Plaster_02.png";
import plasterWall3 from "../assets/thumbnails/wall/Wall_Plaster_03.png";

// Chairs
import blackLeatherChairs from "../assets/thumbnails/chairs/black_leather.png";
import greyLeatherChairs from "../assets/thumbnails/chairs/grey_leather.png";
import brownLeatherChairs from "../assets/thumbnails/chairs/brown_leather.png";
import blueChenylChairs from "../assets/thumbnails/chairs/blue_chenyl.png";

// Sofas
import blackLeatherSofas from "../assets/thumbnails/sofas/Chairs_Black_Leather.png";
import greyLeatherSofas from "../assets/thumbnails/sofas/Chairs_Grey_Leather.png";
import brownLeatherSofas from "../assets/thumbnails/sofas/Chairs_Brown_Leather.png";
import blueChenylSofas from "../assets/thumbnails/sofas/Chairs_Blue_Chenyl.png";

// Blinds
import woodBlinds from "../assets/thumbnails/blinds/wood.png";
import lightMetalBlinds from "../assets/thumbnails/blinds/light_metal.png";
import darkMetalBlinds from "../assets/thumbnails/blinds/dark_metal.png";

// ---- CAMERAS ----
//Cameras Exterior
import cameraEntrance from "../assets/thumbnails/cameras/Camera_Entrance.png";
import cameraKitchen from "../assets/thumbnails/cameras/Camera_Kitchen.png";
import cameraOffice from "../assets/thumbnails/cameras/Camera_Office.png";
import cameraWorkSpace from "../assets/thumbnails/cameras/Camera_Workspace.png";

// ---- VIEW MODE ----
//Cameras Exterior
import eyeLevel from "../assets/thumbnails/view_mode/eye_level.png";
import overView from "../assets/thumbnails/view_mode/overview.png";

// ---- MEDIA ----
//Weather
import sunnyWea from "../assets/thumbnails/weather/sunny.png";
import partlyCloudyWea from "../assets/thumbnails/weather/partly_cloudy.png";
import overcastWea from "../assets/thumbnails/weather/overcast.png";
import rainyWea from "../assets/thumbnails/weather/rainy.png";
import snowyWea from "../assets/thumbnails/weather/snowy.png";
import foggyWea from "../assets/thumbnails/weather/foggy.png";

export const optionsList = {
  cameras: {
    name: "Cameras",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Entrance",
        image: cameraEntrance,
        muiIcon: "",
        randomizable: false,
        customRGB: false,
        inSummary: false,
        price: 0,
        subActions: [],
        action: {
          descriptor: {
            Cam: "en",
          },
          type: "select",
        },
      },
      {
        name: "Kitchen",
        image: cameraKitchen,
        muiIcon: "",
        randomizable: false,
        customRGB: false,
        inSummary: false,
        price: 0,
        subActions: [],
        action: {
          descriptor: {
            Cam: "ki",
          },
          type: "select",
        },
      },
      {
        name: "Office",
        image: cameraOffice,
        muiIcon: "",
        randomizable: false,
        customRGB: false,
        inSummary: false,
        price: 0,
        subActions: [],
        action: {
          descriptor: {
            Cam: "of",
          },
          type: "select",
        },
      },
      {
        name: "WorkSpace",
        image: cameraWorkSpace,
        muiIcon: "",
        randomizable: false,
        customRGB: false,
        inSummary: false,
        price: 0,
        subActions: [],
        action: {
          descriptor: {
            Cam: "ws",
          },
          type: "select",
        },
      },
    ],
  },
  media: [
    {
      name: "View mode",
      image: "",
      muiIcon: "",
      action: {
        type: "tab",
      },
      subActions: [
        {
          image: "",
          muiIcon: "",
          action: {
            type: "select",
          },
          subActions: [
            {
              muiIcon: "",
              subActions: [
                {
                  name: "Eye level",
                  image: eyeLevel,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      ViMo: "el",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Overview",
                  image: overView,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      ViMo: "ov",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Environment",
      image: "",
      muiIcon: "",
      action: {
        type: "select",
      },
      subActions: [
        {
          subActions: [
            {
              name: "Time of the Day",
              muiIcon: "",
              subActions: [
                {
                  name: "Auto",
                  image: "",
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    min: 0,
                    max: 12,
                    step: 0.5,
                    defaultValue: 8,
                    valueLabelFormatter: (value) => {
                      const hoursFromStart = Math.floor(value);
                      const minutesFromStart = (value % 1) * 60;
                      const hours = 6 + hoursFromStart;
                      const minutes = minutesFromStart;
                      const formattedHours = String(hours).padStart(2, "0");
                      const formattedMinutes = String(minutes).padStart(2, "0");
                      return `${formattedHours}:${formattedMinutes}`;
                    },

                    marks: [
                      {
                        value: 0,
                        label: "06:00",
                      },
                      {
                        value: 3,
                        label: "9:00",
                      },
                      {
                        value: 6,
                        label: "12:00",
                      },
                      {
                        value: 9,
                        label: "15:00",
                      },
                      {
                        value: 12,
                        label: "18:00",
                      },
                    ],
                    descriptor: {
                      MeTd: "on",
                    },
                    type: "slider",
                  },
                },
              ],
            },
          ],
        },
        {
          subActions: [
            {
              name: "Weather",
              muiIcon: "",
              subActions: [
                {
                  name: "Sunny",
                  image: sunnyWea,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      MeWe: "su",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Partly Cloudy",
                  image: partlyCloudyWea,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      MeWe: "pc",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Overcast",
                  image: overcastWea,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      MeWe: "oc",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Rainy",
                  image: rainyWea,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      MeWe: "ra",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Snowy",
                  image: snowyWea,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      MeWe: "sn",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Foggy",
                  image: foggyWea,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    descriptor: {
                      MeWe: "fo",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Camera Settings",
      image: "",
      muiIcon: "",
      action: {
        type: "select",
      },
      subActions: [
        {
          muiIcon: "",
          subActions: [
            {
              name: "Focal Length",
              subActions: [
                {
                  name: "mm",
                  image: "",
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    min: 18,
                    max: 100,
                    step: 1,
                    defaultValue: 55,
                    valueLabelFormatter: (value) => {
                      return `${value} mm`;
                    },
                    marks: [
                      {
                        value: 24,
                        label: "24mm",
                      },
                      {
                        value: 55,
                        label: "55mm",
                      },
                      {
                        value: 80,
                        label: "80mm",
                      },
                      {
                        value: 100,
                        label: "100mm",
                      },
                    ],
                    descriptor: {
                      MeCFL: "50mm",
                    },
                    type: "slider",
                  },
                },
              ],
            },
            {
              name: "Aperture",
              muiIcon: "",
              subActions: [
                {
                  name: "steps",
                  image: "",
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    min: 1.2,
                    max: 22,
                    step: 0.2,
                    defaultValue: 6,
                    valueLabelFormatter: (value) => {
                      return `f/${value}`;
                    },
                    marks: [
                      {
                        value: 1.4,
                        label: "f/1.4",
                      },
                      {
                        value: 5.6,
                        label: "f/5.6",
                      },
                      {
                        value: 8,
                        label: "f/8",
                      },
                      {
                        value: 16,
                        label: "f/16",
                      },
                      {
                        value: 22,
                        label: "f/22",
                      },
                    ],
                    descriptor: {
                      MeCAp: "f/2.8",
                    },
                    type: "slider",
                  },
                },
              ],
            },
            {
              name: "Exposure",
              muiIcon: "",
              subActions: [
                {
                  name: "",
                  image: "",
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    min: -2,
                    max: 2,
                    step: 0.1,
                    defaultValue: 1,
                    marks: [
                      {
                        value: -2,
                        label: "-2",
                      },
                      {
                        value: -1,
                        label: "-1",
                      },
                      {
                        value: 0,
                        label: "0",
                      },
                      {
                        value: 1,
                        label: "+1",
                      },
                      {
                        value: 2,
                        label: "+2",
                      },
                    ],
                    descriptor: {
                      MeCEx: "0.0",
                    },
                    type: "slider",
                  },
                },
              ],
            },
            {
              name: "Contrast",
              muiIcon: "",
              subActions: [
                {
                  name: "",
                  image: "",
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 0,
                  subActions: [],
                  action: {
                    min: 0.5,
                    max: 2,
                    step: 0.1,
                    defaultValue: 1,
                    marks: [
                      {
                        value: 0.5,
                        label: "0.5",
                      },
                      {
                        value: 1,
                        label: "1",
                      },
                      {
                        value: 1.5,
                        label: "1.5",
                      },
                      {
                        value: 2,
                        label: "2",
                      },
                    ],
                    descriptor: {
                      MeCCo: "10",
                    },
                    type: "slider",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    // {
    //   name: "Export Image",
    //   image: "",
    //   muiIcon: "",
    //   action: {
    //     type: "select",
    //   },
    //   subActions: [],
    // },
  ],
  options: [
    {
      name: "Layout",
      image: "",
      muiIcon: "",
      action: {
        type: "tab",
      },
      subActions: [
        {
          image: "",
          name: "Layout",
          displayName: false,
          muiIcon: "",
          action: {
            type: "select",
          },
          subActions: [
            {
              muiIcon: "",
              subActions: [
                {
                  name: "Work Space 01",
                  image: workSpace01,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 9900,
                  subActions: [],
                  action: {
                    descriptor: {
                      WS: "ws01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Work Space 02",
                  image: workSpace02,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 11490,
                  subActions: [],
                  action: {
                    descriptor: {
                      WS: "ws02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Work Space 03",
                  image: workSpace03,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 14950,
                  subActions: [],
                  action: {
                    descriptor: {
                      WS: "ws03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Base price",
                  image: "",
                  muiIcon: "",
                  baseOption: true,
                  action: {
                    type: "select",
                  },
                  subActions: [
                    {
                      name: "Base price",
                      muiIcon: "",
                      subActions: [
                        {
                          name: "Base price",
                          image: "",
                          muiIcon: "",
                          randomizable: true,
                          customRGB: false,
                          inSummary: true,
                          price: 245750,
                          subActions: [],
                          action: {
                            descriptor: {
                              basePrice: true,
                            },
                            type: "select",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Materials",
      image: "",
      muiIcon: "",
      action: {
        type: "tab",
      },
      subActions: [
        {
          name: "Floor",
          image: "",
          muiIcon: "",
          action: {
            type: "select",
          },
          subActions: [
            {
              name: "Floor",
              muiIcon: "",
              subActions: [
                {
                  name: "Light Maple",
                  image: woodFloor1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 7990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "wo01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Pine",
                  image: woodFloor2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 3990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "wo02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Oak",
                  image: woodFloor3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 5990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "wo03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Cinnamon Carpet",
                  image: carpetFloor1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 5990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "car01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Khaki Gold Carpet",
                  image: carpetFloor2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 4990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "car02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Teal Carpet",
                  image: carpetFloor3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 6490,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "car03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Light Grey Concrete",
                  image: concreteFloor1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 5990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "con01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Medium Taupe Concrete",
                  image: concreteFloor2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 6990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "con02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Brown Concrete",
                  image: concreteFloor3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 7990,
                  subActions: [],
                  action: {
                    descriptor: {
                      FlCo: "con03",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
        {
          name: "Ceiling",
          image: "",
          muiIcon: "",
          action: {
            type: "select",
          },
          subActions: [
            {
              name: "Ceiling",
              muiIcon: "",
              subActions: [
                {
                  name: "Veneer Polished Wood",
                  image: woodCeiling1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 8990,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "wo01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Oak Plank Wood",
                  image: woodCeiling2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 6490,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "wo02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Maple Glossy Wood",
                  image: woodCeiling3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 9290,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "wo03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Raw Dark Concrete",
                  image: concreteCeiling1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 9425,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "con01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Raw Light Concrete",
                  image: concreteCeiling2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 10290,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "con02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Raw Medium Concrete",
                  image: concreteCeiling3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 13990,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "con03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "White Plaster",
                  image: plasterCeiling1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 4190,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "pl01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Taupe Plaster",
                  image: plasterCeiling2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 4890,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "pl02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Plaster",
                  image: plasterCeiling3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 5350,
                  subActions: [],
                  action: {
                    descriptor: {
                      CeCo: "pl03",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
        {
          name: "Walls",
          image: "",
          muiIcon: "",
          action: {
            type: "select",
          },
          subActions: [
            {
              name: "Walls",
              muiIcon: "",
              subActions: [
                {
                  name: "Redwood Wood",
                  image: woodWall1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 9150,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "wo01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Straight Grain Wood",
                  image: woodWall2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 10190,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "wo02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Walnut Wood",
                  image: woodWall3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 12890,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "wo03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Rough Red Brick",
                  image: bricksWall1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 5990,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "br01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Brown Brick",
                  image: bricksWall2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 6590,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "br02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Grey Brick",
                  image: bricksWall3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 6990,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "br03",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Mauve Plaster",
                  image: plasterWall1,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 3690,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "pl01",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Brown Plaster",
                  image: plasterWall2,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 3990,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "pl02",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Mocha Plaster",
                  image: plasterWall3,
                  muiIcon: "",
                  randomizable: true,
                  customRGB: false,
                  inSummary: true,
                  price: 4350,
                  subActions: [],
                  action: {
                    descriptor: {
                      WaCo: "pl03",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Chairs",
      image: "",
      muiIcon: "",
      action: {
        type: "tab",
      },
      subActions: [
        {
          name: "Chairs",
          image: "",
          muiIcon: "",
          displayName: false,
          action: {
            type: "select",
          },
          subActions: [
            {
              muiIcon: "",
              subActions: [
                {
                  name: "Black Leather",
                  image: blackLeatherChairs,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 29500,
                  subActions: [],
                  action: {
                    descriptor: {
                      ChCo: "bl",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Grey Leather",
                  image: greyLeatherChairs,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 29500,
                  subActions: [],
                  action: {
                    descriptor: {
                      ChCo: "gl",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Brown Leather",
                  image: brownLeatherChairs,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 29500,
                  subActions: [],
                  action: {
                    descriptor: {
                      ChCo: "brl",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Blue Chenyl",
                  image: blueChenylChairs,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 19500,
                  subActions: [],
                  action: {
                    descriptor: {
                      ChCo: "bc",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Sofas",
      image: "",
      muiIcon: "",
      action: {
        type: "tab",
      },
      subActions: [
        {
          name: "Sofas",
          displayName: false,
          image: "",
          muiIcon: "",
          action: {
            type: "select",
          },
          subActions: [
            {
              muiIcon: "",
              subActions: [
                {
                  name: "Black Leather",
                  image: blackLeatherSofas,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 32590,
                  subActions: [],
                  action: {
                    descriptor: {
                      SoCo: "bl",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Grey Leather",
                  image: greyLeatherSofas,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 32590,
                  subActions: [],
                  action: {
                    descriptor: {
                      SoCo: "gl",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Brown Leather",
                  image: brownLeatherSofas,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 32590,
                  subActions: [],
                  action: {
                    descriptor: {
                      SoCo: "brl",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Blue Chenyl",
                  image: blueChenylSofas,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 20590,
                  subActions: [],
                  action: {
                    descriptor: {
                      SoCo: "bc",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Blinds",
      image: "",
      muiIcon: "",
      action: {
        type: "tab",
      },
      subActions: [
        {
          name: "Blinds",
          image: "",
          muiIcon: "",
          displayName: false,
          action: {
            type: "select",
          },
          subActions: [
            {
              muiIcon: "",
              subActions: [
                {
                  name: "Wood",
                  image: woodBlinds,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 12590,
                  subActions: [],
                  action: {
                    descriptor: {
                      BlCo: "wo",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Dark Metal",
                  image: darkMetalBlinds,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 18590,
                  subActions: [],
                  action: {
                    descriptor: {
                      BlCo: "dm",
                    },
                    type: "select",
                  },
                },
                {
                  name: "Light Metal",
                  image: lightMetalBlinds,
                  muiIcon: "",
                  randomizable: false,
                  customRGB: false,
                  inSummary: false,
                  price: 18590,
                  subActions: [],
                  action: {
                    descriptor: {
                      BlCo: "lm",
                    },
                    type: "select",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
